import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n/i18n';
import ReactGA from 'react-ga4';
import { HOSTNAME_PRODUCTION } from 'env';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
if (window.location.hostname === HOSTNAME_PRODUCTION) {
  ReactGA.initialize('G-CEYK05NBFJ');
}

root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
